// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Contenedor principal */
.scrapingContainer_k6sSL {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* Indicador de estado */
.statusIndicator_j6nr8 {
    margin-bottom: 30px;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 8px;
}

.statusSteps_bBHGx {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
}

.statusSteps_bBHGx::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 2px;
    background: #e9ecef;
    z-index: 1;
}

.statusStep_scqqH {
    position: relative;
    z-index: 2;
    background: #ffffff;
    padding: 12px 20px;
    border-radius: 25px;
    border: 2px solid #e9ecef;
    font-weight: 500;
    color: #6c757d;
    transition: all 0.3s ease;
    min-width: 120px;
    text-align: center;
}

.statusStep_scqqH.active_O4b3X {
    border-color: #007bff;
    color: #007bff;
    background: #e3f2fd;
    box-shadow: 0 2px 8px rgba(0, 123, 255, 0.2);
}

/* ===== ESTADO LOADING ===== */
.loadingContainer_IgdiV {
    padding: 20px;
}

.loadingHeader_bWt_d {
    text-align: center;
    margin-bottom: 30px;
}

.loadingHeader_bWt_d h3 {
    font-size: 24px;
    color: #333;
    margin-bottom: 10px;
}

.loadingHeader_bWt_d p {
    color: #666;
    font-size: 16px;
}

.urlInputContainer_CxMr3 {
    display: flex;
    gap: 15px;
    margin-bottom: 30px;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
}

.urlInput_u3JUW {
    flex: 1 1;
    padding: 15px;
    border: 2px solid #e9ecef;
    border-radius: 8px;
    font-size: 16px;
    transition: border-color 0.3s ease;
}

.urlInput_u3JUW:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.loadButton_axuBl {
    padding: 15px 30px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
}

.loadButton_axuBl:hover:not(:disabled) {
    background: #0056b3;
    transform: translateY(-1px);
}

.loadButton_axuBl:disabled {
    background: #6c757d;
    cursor: not-allowed;
    transform: none;
}

.progressContainer_Py9sM {
    margin: 30px 0;
    text-align: center;
}

.progressBar_wsGYD {
    width: 100%;
    height: 8px;
    background: #e9ecef;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 10px;
}

.progressFill_lH70O {
    height: 100%;
    background: linear-gradient(90deg, #007bff, #28a745);
    border-radius: 4px;
    transition: width 0.3s ease;
}

.progressText_UQiln {
    font-size: 14px;
    color: #666;
    font-weight: 500;
}

.screenshotPreview_EUY9b {
    margin-top: 30px;
    text-align: center;
}

.screenshotPreview_EUY9b h4 {
    margin-bottom: 15px;
    color: #333;
}

.screenshotImage_EBrmz {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* ===== ESTADO SELECTOR ===== */
.selectorContainer_QfJqj {
    padding: 20px;
}

.selectorHeader_W7Vq3 {
    text-align: center;
    margin-bottom: 30px;
}

.selectorHeader_W7Vq3 h3 {
    font-size: 24px;
    color: #333;
    margin-bottom: 10px;
}

.selectorHeader_W7Vq3 p {
    color: #666;
    font-size: 16px;
}

.selectorContent_d1X1Q {
    display: grid;
    grid-template-columns: 1fr 400px;
    gap: 30px;
    align-items: start;
}

.screenshotContainer_HBmZ9 {
    position: relative;
}

.screenshotWrapper_LmEpz {
    position: relative;
    display: inline-block;
}

.selectorOverlay_lPlYp {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
}

.selectorBox_H22mG {
    position: absolute;
    border: 2px solid #007bff;
    background: rgba(0, 123, 255, 0.1);
    border-radius: 4px;
    pointer-events: none;
}

.selectorLabel_lehJE {
    position: absolute;
    top: -25px;
    left: 0;
    background: #007bff;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
}

.selectedElement_CMaB2 {
    position: absolute;
    border: 2px solid #28a745;
    background: rgba(40, 167, 69, 0.1);
    border-radius: 4px;
    pointer-events: none;
}

.selectorControls_ZBLj6 {
    background: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
    height: fit-content;
}

.selectionButtons_N5VF_ {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 20px;
}

.selectionButton_nFEkt {
    padding: 12px 20px;
    background: #6c757d;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
}

.selectionButton_nFEkt:hover {
    background: #5a6268;
}

.selectionButton_nFEkt.active_O4b3X {
    background: #28a745;
}

.continueButton_CR6ME {
    padding: 15px 20px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
}

.continueButton_CR6ME:hover:not(:disabled) {
    background: #0056b3;
}

.continueButton_CR6ME:disabled {
    background: #6c757d;
    cursor: not-allowed;
}

.selectorForm_K31Ac {
    background: white;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    border: 1px solid #e9ecef;
}

.selectorForm_K31Ac h4 {
    margin-bottom: 15px;
    color: #333;
}

.selectorInput_LhHPX,
.selectorSelect_gxme9,
.selectorTextarea_ZyjFq {
    width: 100%;
    padding: 10px;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    margin-bottom: 10px;
    font-size: 14px;
}

.selectorInput_LhHPX:focus,
.selectorSelect_gxme9:focus,
.selectorTextarea_ZyjFq:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
}

.selectorActions_fdmed {
    display: flex;
    gap: 10px;
}

.addButton_we6Et,
.cancelButton_d74kJ {
    flex: 1 1;
    padding: 10px;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
}

.addButton_we6Et {
    background: #28a745;
    color: white;
}

.addButton_we6Et:hover {
    background: #218838;
}

.cancelButton_d74kJ {
    background: #dc3545;
    color: white;
}

.cancelButton_d74kJ:hover {
    background: #c82333;
}

.selectorsList_tFydt {
    background: white;
    padding: 20px;
    border-radius: 8px;
    border: 1px solid #e9ecef;
}

.selectorsList_tFydt h4 {
    margin-bottom: 15px;
    color: #333;
}

.selectorItem_ufm2a {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    margin-bottom: 10px;
    background: #f8f9fa;
}

.selectorInfo_EiZ8m {
    flex: 1 1;
}

.selectorInfo_EiZ8m strong {
    display: block;
    color: #333;
    margin-bottom: 4px;
}

.selectorType_zR_i8 {
    display: inline-block;
    background: #007bff;
    color: white;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
    margin-right: 8px;
}

.selectorPath_KaD4o {
    color: #666;
    font-size: 12px;
    font-family: monospace;
}

.removeButton_ypHhk {
    background: #dc3545;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 6px 10px;
    cursor: pointer;
    transition: background 0.3s ease;
}

.removeButton_ypHhk:hover {
    background: #c82333;
}

/* ===== ESTADO TEMPLATE ===== */
.templateContainer_dl42I {
    padding: 20px;
}

.templateHeader_AeaQf {
    text-align: center;
    margin-bottom: 30px;
}

.templateHeader_AeaQf h3 {
    font-size: 24px;
    color: #333;
    margin-bottom: 10px;
}

.templateHeader_AeaQf p {
    color: #666;
    font-size: 16px;
}

.templateContent_uwtKp {
    max-width: 800px;
    margin: 0 auto;
}

.templateInfo_vE406 {
    margin-bottom: 30px;
}

.templateNameInput_ctN5M,
.templateDescriptionInput_UuUyB {
    width: 100%;
    padding: 15px;
    border: 2px solid #e9ecef;
    border-radius: 8px;
    font-size: 16px;
    margin-bottom: 15px;
    transition: border-color 0.3s ease;
}

.templateNameInput_ctN5M:focus,
.templateDescriptionInput_UuUyB:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.stepsContainer_xk7mO {
    background: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 30px;
}

.stepsContainer_xk7mO h4 {
    margin-bottom: 20px;
    color: #333;
}

.stepsList_LJNM6 {
    margin-bottom: 20px;
}

.stepItem_aHyQh {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    margin-bottom: 10px;
}

.stepHeader_Di766 {
    display: flex;
    align-items: center;
    gap: 15px;
}

.stepNumber_Jvdjn {
    background: #007bff;
    color: white;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 14px;
}

.stepType_c6ITv {
    background: #6c757d;
    color: white;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
}

.stepActions_urzia {
    display: flex;
    gap: 5px;
}

.stepActions_urzia button {
    background: #6c757d;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 6px 10px;
    cursor: pointer;
    transition: background 0.3s ease;
    font-size: 12px;
}

.stepActions_urzia button:hover {
    background: #5a6268;
}

.stepActions_urzia button:disabled {
    background: #adb5bd;
    cursor: not-allowed;
}

.addStepForm_IfQHU {
    background: white;
    padding: 20px;
    border-radius: 6px;
    border: 1px solid #e9ecef;
}

.addStepForm_IfQHU h4 {
    margin-bottom: 15px;
    color: #333;
}

.stepInput_haG3V,
.stepSelect_evUjj {
    width: 100%;
    padding: 10px;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    margin-bottom: 10px;
    font-size: 14px;
}

.stepInput_haG3V:focus,
.stepSelect_evUjj:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
}

.addStepButton_kAWvh {
    width: 100%;
    padding: 12px;
    background: #28a745;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.addStepButton_kAWvh:hover {
    background: #218838;
}

.templateActions_P3WS1 {
    display: flex;
    gap: 15px;
    justify-content: center;
}

.saveButton_CrT_p,
.executeButton_cR3UZ {
    padding: 15px 30px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
}

.saveButton_CrT_p {
    background: #28a745;
    color: white;
}

.saveButton_CrT_p:hover {
    background: #218838;
    transform: translateY(-1px);
}

.executeButton_cR3UZ {
    background: #007bff;
    color: white;
}

.executeButton_cR3UZ:hover:not(:disabled) {
    background: #0056b3;
    transform: translateY(-1px);
}

.executeButton_cR3UZ:disabled {
    background: #6c757d;
    cursor: not-allowed;
    transform: none;
}

/* ===== ESTADO EXAMPLE ===== */
.exampleContainer_lXAe4 {
    padding: 20px;
}

.exampleHeader_Oh7dB {
    text-align: center;
    margin-bottom: 30px;
}

.exampleHeader_Oh7dB h3 {
    font-size: 24px;
    color: #333;
    margin-bottom: 10px;
}

.exampleHeader_Oh7dB p {
    color: #666;
    font-size: 16px;
}

.exampleContent_tjDTj {
    max-width: 1000px;
    margin: 0 auto;
}

.executionControls_XeikW {
    text-align: center;
    margin-bottom: 30px;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 8px;
}

.executionTime_eYUnt {
    margin-top: 15px;
    font-size: 14px;
    color: #666;
    font-weight: 500;
}

.resultsContainer_GlAzG {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 30px;
}

.resultsContainer_GlAzG h4 {
    padding: 20px;
    margin: 0;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    color: #333;
}

.resultsTable_iXqD3 {
    overflow-x: auto;
}

.resultsTable_iXqD3 table {
    width: 100%;
    border-collapse: collapse;
}

.resultsTable_iXqD3 th,
.resultsTable_iXqD3 td {
    padding: 12px 15px;
    text-align: left;
    border-bottom: 1px solid #e9ecef;
}

.resultsTable_iXqD3 th {
    background: #f8f9fa;
    font-weight: 600;
    color: #333;
}

.resultsTable_iXqD3 tr:hover {
    background: #f8f9fa;
}

.status_FH5B9 {
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
}

.status_FH5B9.success_EO4Rg {
    background: #d4edda;
    color: #155724;
}

.status_FH5B9.error_sYyVc {
    background: #f8d7da;
    color: #721c24;
}

.status_FH5B9.warning_A41PC {
    background: #fff3cd;
    color: #856404;
}

.noResults_roBD3 {
    padding: 40px;
    text-align: center;
    color: #666;
}

.exampleActions_Qyekb {
    display: flex;
    gap: 15px;
    justify-content: center;
}

.backButton_nFWeG,
.newScrapingButton_Vrnbb {
    padding: 12px 24px;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.backButton_nFWeG {
    background: #6c757d;
    color: white;
}

.backButton_nFWeG:hover {
    background: #5a6268;
}

.newScrapingButton_Vrnbb {
    background: #28a745;
    color: white;
}

.newScrapingButton_Vrnbb:hover {
    background: #218838;
}

/* ===== ESTADO ERROR ===== */
.errorContainer_C25lC {
    text-align: center;
    padding: 40px;
}

.errorContainer_C25lC h3 {
    color: #dc3545;
    margin-bottom: 15px;
}

.errorContainer_C25lC button {
    padding: 12px 24px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.3s ease;
}

.errorContainer_C25lC button:hover {
    background: #0056b3;
}

/* Responsive */
@media (max-width: 768px) {
    .scrapingContainer_k6sSL {
        padding: 15px;
    }
    
    .statusSteps_bBHGx {
        flex-direction: column;
        gap: 15px;
    }
    
    .statusSteps_bBHGx::before {
        display: none;
    }
    
    .selectorContent_d1X1Q {
        grid-template-columns: 1fr;
        gap: 20px;
    }
    
    .urlInputContainer_CxMr3 {
        flex-direction: column;
    }
    
    .templateActions_P3WS1,
    .exampleActions_Qyekb {
        flex-direction: column;
    }
    
    .stepItem_aHyQh {
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
    }
    
    .stepActions_urzia {
        align-self: flex-end;
    }
} `, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/ChatView/ScrapingContainer/ScrapingContainer.module.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yCAAyC;IACzC,8EAA8E;AAClF;;AAEA,wBAAwB;AACxB;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA,+BAA+B;AAC/B;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,oDAAoD;IACpD,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA,gCAAgC;AAChC;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kCAAkC;IAClC,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kCAAkC;IAClC,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;;;IAGI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;;IAGI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;;IAEI,SAAO;IACP,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA,gCAAgC;AAChC;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;;IAEI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA,+BAA+B;AAC/B;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;;IAEI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,uBAAuB;IAC3B;;IAEA;QACI,oBAAoB;IACxB;AACJ","sourcesContent":["/* Contenedor principal */\n.scrapingContainer {\n    width: 100%;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n    background: #ffffff;\n    border-radius: 12px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n/* Indicador de estado */\n.statusIndicator {\n    margin-bottom: 30px;\n    padding: 20px;\n    background: #f8f9fa;\n    border-radius: 8px;\n}\n\n.statusSteps {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n}\n\n.statusSteps::before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 0;\n    right: 0;\n    height: 2px;\n    background: #e9ecef;\n    z-index: 1;\n}\n\n.statusStep {\n    position: relative;\n    z-index: 2;\n    background: #ffffff;\n    padding: 12px 20px;\n    border-radius: 25px;\n    border: 2px solid #e9ecef;\n    font-weight: 500;\n    color: #6c757d;\n    transition: all 0.3s ease;\n    min-width: 120px;\n    text-align: center;\n}\n\n.statusStep.active {\n    border-color: #007bff;\n    color: #007bff;\n    background: #e3f2fd;\n    box-shadow: 0 2px 8px rgba(0, 123, 255, 0.2);\n}\n\n/* ===== ESTADO LOADING ===== */\n.loadingContainer {\n    padding: 20px;\n}\n\n.loadingHeader {\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n.loadingHeader h3 {\n    font-size: 24px;\n    color: #333;\n    margin-bottom: 10px;\n}\n\n.loadingHeader p {\n    color: #666;\n    font-size: 16px;\n}\n\n.urlInputContainer {\n    display: flex;\n    gap: 15px;\n    margin-bottom: 30px;\n    max-width: 600px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.urlInput {\n    flex: 1;\n    padding: 15px;\n    border: 2px solid #e9ecef;\n    border-radius: 8px;\n    font-size: 16px;\n    transition: border-color 0.3s ease;\n}\n\n.urlInput:focus {\n    outline: none;\n    border-color: #007bff;\n    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n}\n\n.loadButton {\n    padding: 15px 30px;\n    background: #007bff;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.loadButton:hover:not(:disabled) {\n    background: #0056b3;\n    transform: translateY(-1px);\n}\n\n.loadButton:disabled {\n    background: #6c757d;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.progressContainer {\n    margin: 30px 0;\n    text-align: center;\n}\n\n.progressBar {\n    width: 100%;\n    height: 8px;\n    background: #e9ecef;\n    border-radius: 4px;\n    overflow: hidden;\n    margin-bottom: 10px;\n}\n\n.progressFill {\n    height: 100%;\n    background: linear-gradient(90deg, #007bff, #28a745);\n    border-radius: 4px;\n    transition: width 0.3s ease;\n}\n\n.progressText {\n    font-size: 14px;\n    color: #666;\n    font-weight: 500;\n}\n\n.screenshotPreview {\n    margin-top: 30px;\n    text-align: center;\n}\n\n.screenshotPreview h4 {\n    margin-bottom: 15px;\n    color: #333;\n}\n\n.screenshotImage {\n    max-width: 100%;\n    height: auto;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* ===== ESTADO SELECTOR ===== */\n.selectorContainer {\n    padding: 20px;\n}\n\n.selectorHeader {\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n.selectorHeader h3 {\n    font-size: 24px;\n    color: #333;\n    margin-bottom: 10px;\n}\n\n.selectorHeader p {\n    color: #666;\n    font-size: 16px;\n}\n\n.selectorContent {\n    display: grid;\n    grid-template-columns: 1fr 400px;\n    gap: 30px;\n    align-items: start;\n}\n\n.screenshotContainer {\n    position: relative;\n}\n\n.screenshotWrapper {\n    position: relative;\n    display: inline-block;\n}\n\n.selectorOverlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n}\n\n.selectorBox {\n    position: absolute;\n    border: 2px solid #007bff;\n    background: rgba(0, 123, 255, 0.1);\n    border-radius: 4px;\n    pointer-events: none;\n}\n\n.selectorLabel {\n    position: absolute;\n    top: -25px;\n    left: 0;\n    background: #007bff;\n    color: white;\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 12px;\n    font-weight: 500;\n    white-space: nowrap;\n}\n\n.selectedElement {\n    position: absolute;\n    border: 2px solid #28a745;\n    background: rgba(40, 167, 69, 0.1);\n    border-radius: 4px;\n    pointer-events: none;\n}\n\n.selectorControls {\n    background: #f8f9fa;\n    padding: 20px;\n    border-radius: 8px;\n    height: fit-content;\n}\n\n.selectionButtons {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    margin-bottom: 20px;\n}\n\n.selectionButton {\n    padding: 12px 20px;\n    background: #6c757d;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    font-size: 14px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.selectionButton:hover {\n    background: #5a6268;\n}\n\n.selectionButton.active {\n    background: #28a745;\n}\n\n.continueButton {\n    padding: 15px 20px;\n    background: #007bff;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.continueButton:hover:not(:disabled) {\n    background: #0056b3;\n}\n\n.continueButton:disabled {\n    background: #6c757d;\n    cursor: not-allowed;\n}\n\n.selectorForm {\n    background: white;\n    padding: 20px;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    border: 1px solid #e9ecef;\n}\n\n.selectorForm h4 {\n    margin-bottom: 15px;\n    color: #333;\n}\n\n.selectorInput,\n.selectorSelect,\n.selectorTextarea {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #e9ecef;\n    border-radius: 4px;\n    margin-bottom: 10px;\n    font-size: 14px;\n}\n\n.selectorInput:focus,\n.selectorSelect:focus,\n.selectorTextarea:focus {\n    outline: none;\n    border-color: #007bff;\n    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);\n}\n\n.selectorActions {\n    display: flex;\n    gap: 10px;\n}\n\n.addButton,\n.cancelButton {\n    flex: 1;\n    padding: 10px;\n    border: none;\n    border-radius: 4px;\n    font-size: 14px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n}\n\n.addButton {\n    background: #28a745;\n    color: white;\n}\n\n.addButton:hover {\n    background: #218838;\n}\n\n.cancelButton {\n    background: #dc3545;\n    color: white;\n}\n\n.cancelButton:hover {\n    background: #c82333;\n}\n\n.selectorsList {\n    background: white;\n    padding: 20px;\n    border-radius: 8px;\n    border: 1px solid #e9ecef;\n}\n\n.selectorsList h4 {\n    margin-bottom: 15px;\n    color: #333;\n}\n\n.selectorItem {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px;\n    border: 1px solid #e9ecef;\n    border-radius: 6px;\n    margin-bottom: 10px;\n    background: #f8f9fa;\n}\n\n.selectorInfo {\n    flex: 1;\n}\n\n.selectorInfo strong {\n    display: block;\n    color: #333;\n    margin-bottom: 4px;\n}\n\n.selectorType {\n    display: inline-block;\n    background: #007bff;\n    color: white;\n    padding: 2px 8px;\n    border-radius: 12px;\n    font-size: 12px;\n    margin-right: 8px;\n}\n\n.selectorPath {\n    color: #666;\n    font-size: 12px;\n    font-family: monospace;\n}\n\n.removeButton {\n    background: #dc3545;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    padding: 6px 10px;\n    cursor: pointer;\n    transition: background 0.3s ease;\n}\n\n.removeButton:hover {\n    background: #c82333;\n}\n\n/* ===== ESTADO TEMPLATE ===== */\n.templateContainer {\n    padding: 20px;\n}\n\n.templateHeader {\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n.templateHeader h3 {\n    font-size: 24px;\n    color: #333;\n    margin-bottom: 10px;\n}\n\n.templateHeader p {\n    color: #666;\n    font-size: 16px;\n}\n\n.templateContent {\n    max-width: 800px;\n    margin: 0 auto;\n}\n\n.templateInfo {\n    margin-bottom: 30px;\n}\n\n.templateNameInput,\n.templateDescriptionInput {\n    width: 100%;\n    padding: 15px;\n    border: 2px solid #e9ecef;\n    border-radius: 8px;\n    font-size: 16px;\n    margin-bottom: 15px;\n    transition: border-color 0.3s ease;\n}\n\n.templateNameInput:focus,\n.templateDescriptionInput:focus {\n    outline: none;\n    border-color: #007bff;\n    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n}\n\n.stepsContainer {\n    background: #f8f9fa;\n    padding: 20px;\n    border-radius: 8px;\n    margin-bottom: 30px;\n}\n\n.stepsContainer h4 {\n    margin-bottom: 20px;\n    color: #333;\n}\n\n.stepsList {\n    margin-bottom: 20px;\n}\n\n.stepItem {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px;\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 6px;\n    margin-bottom: 10px;\n}\n\n.stepHeader {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n}\n\n.stepNumber {\n    background: #007bff;\n    color: white;\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n    font-size: 14px;\n}\n\n.stepType {\n    background: #6c757d;\n    color: white;\n    padding: 4px 8px;\n    border-radius: 12px;\n    font-size: 12px;\n}\n\n.stepActions {\n    display: flex;\n    gap: 5px;\n}\n\n.stepActions button {\n    background: #6c757d;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    padding: 6px 10px;\n    cursor: pointer;\n    transition: background 0.3s ease;\n    font-size: 12px;\n}\n\n.stepActions button:hover {\n    background: #5a6268;\n}\n\n.stepActions button:disabled {\n    background: #adb5bd;\n    cursor: not-allowed;\n}\n\n.addStepForm {\n    background: white;\n    padding: 20px;\n    border-radius: 6px;\n    border: 1px solid #e9ecef;\n}\n\n.addStepForm h4 {\n    margin-bottom: 15px;\n    color: #333;\n}\n\n.stepInput,\n.stepSelect {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #e9ecef;\n    border-radius: 4px;\n    margin-bottom: 10px;\n    font-size: 14px;\n}\n\n.stepInput:focus,\n.stepSelect:focus {\n    outline: none;\n    border-color: #007bff;\n    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);\n}\n\n.addStepButton {\n    width: 100%;\n    padding: 12px;\n    background: #28a745;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    font-size: 14px;\n    cursor: pointer;\n    transition: background 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.addStepButton:hover {\n    background: #218838;\n}\n\n.templateActions {\n    display: flex;\n    gap: 15px;\n    justify-content: center;\n}\n\n.saveButton,\n.executeButton {\n    padding: 15px 30px;\n    border: none;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.saveButton {\n    background: #28a745;\n    color: white;\n}\n\n.saveButton:hover {\n    background: #218838;\n    transform: translateY(-1px);\n}\n\n.executeButton {\n    background: #007bff;\n    color: white;\n}\n\n.executeButton:hover:not(:disabled) {\n    background: #0056b3;\n    transform: translateY(-1px);\n}\n\n.executeButton:disabled {\n    background: #6c757d;\n    cursor: not-allowed;\n    transform: none;\n}\n\n/* ===== ESTADO EXAMPLE ===== */\n.exampleContainer {\n    padding: 20px;\n}\n\n.exampleHeader {\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n.exampleHeader h3 {\n    font-size: 24px;\n    color: #333;\n    margin-bottom: 10px;\n}\n\n.exampleHeader p {\n    color: #666;\n    font-size: 16px;\n}\n\n.exampleContent {\n    max-width: 1000px;\n    margin: 0 auto;\n}\n\n.executionControls {\n    text-align: center;\n    margin-bottom: 30px;\n    padding: 20px;\n    background: #f8f9fa;\n    border-radius: 8px;\n}\n\n.executionTime {\n    margin-top: 15px;\n    font-size: 14px;\n    color: #666;\n    font-weight: 500;\n}\n\n.resultsContainer {\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 8px;\n    overflow: hidden;\n    margin-bottom: 30px;\n}\n\n.resultsContainer h4 {\n    padding: 20px;\n    margin: 0;\n    background: #f8f9fa;\n    border-bottom: 1px solid #e9ecef;\n    color: #333;\n}\n\n.resultsTable {\n    overflow-x: auto;\n}\n\n.resultsTable table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.resultsTable th,\n.resultsTable td {\n    padding: 12px 15px;\n    text-align: left;\n    border-bottom: 1px solid #e9ecef;\n}\n\n.resultsTable th {\n    background: #f8f9fa;\n    font-weight: 600;\n    color: #333;\n}\n\n.resultsTable tr:hover {\n    background: #f8f9fa;\n}\n\n.status {\n    padding: 4px 8px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 500;\n}\n\n.status.success {\n    background: #d4edda;\n    color: #155724;\n}\n\n.status.error {\n    background: #f8d7da;\n    color: #721c24;\n}\n\n.status.warning {\n    background: #fff3cd;\n    color: #856404;\n}\n\n.noResults {\n    padding: 40px;\n    text-align: center;\n    color: #666;\n}\n\n.exampleActions {\n    display: flex;\n    gap: 15px;\n    justify-content: center;\n}\n\n.backButton,\n.newScrapingButton {\n    padding: 12px 24px;\n    border: none;\n    border-radius: 6px;\n    font-size: 14px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.backButton {\n    background: #6c757d;\n    color: white;\n}\n\n.backButton:hover {\n    background: #5a6268;\n}\n\n.newScrapingButton {\n    background: #28a745;\n    color: white;\n}\n\n.newScrapingButton:hover {\n    background: #218838;\n}\n\n/* ===== ESTADO ERROR ===== */\n.errorContainer {\n    text-align: center;\n    padding: 40px;\n}\n\n.errorContainer h3 {\n    color: #dc3545;\n    margin-bottom: 15px;\n}\n\n.errorContainer button {\n    padding: 12px 24px;\n    background: #007bff;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background 0.3s ease;\n}\n\n.errorContainer button:hover {\n    background: #0056b3;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .scrapingContainer {\n        padding: 15px;\n    }\n    \n    .statusSteps {\n        flex-direction: column;\n        gap: 15px;\n    }\n    \n    .statusSteps::before {\n        display: none;\n    }\n    \n    .selectorContent {\n        grid-template-columns: 1fr;\n        gap: 20px;\n    }\n    \n    .urlInputContainer {\n        flex-direction: column;\n    }\n    \n    .templateActions,\n    .exampleActions {\n        flex-direction: column;\n    }\n    \n    .stepItem {\n        flex-direction: column;\n        gap: 10px;\n        align-items: flex-start;\n    }\n    \n    .stepActions {\n        align-self: flex-end;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrapingContainer": `scrapingContainer_k6sSL`,
	"statusIndicator": `statusIndicator_j6nr8`,
	"statusSteps": `statusSteps_bBHGx`,
	"statusStep": `statusStep_scqqH`,
	"active": `active_O4b3X`,
	"loadingContainer": `loadingContainer_IgdiV`,
	"loadingHeader": `loadingHeader_bWt_d`,
	"urlInputContainer": `urlInputContainer_CxMr3`,
	"urlInput": `urlInput_u3JUW`,
	"loadButton": `loadButton_axuBl`,
	"progressContainer": `progressContainer_Py9sM`,
	"progressBar": `progressBar_wsGYD`,
	"progressFill": `progressFill_lH70O`,
	"progressText": `progressText_UQiln`,
	"screenshotPreview": `screenshotPreview_EUY9b`,
	"screenshotImage": `screenshotImage_EBrmz`,
	"selectorContainer": `selectorContainer_QfJqj`,
	"selectorHeader": `selectorHeader_W7Vq3`,
	"selectorContent": `selectorContent_d1X1Q`,
	"screenshotContainer": `screenshotContainer_HBmZ9`,
	"screenshotWrapper": `screenshotWrapper_LmEpz`,
	"selectorOverlay": `selectorOverlay_lPlYp`,
	"selectorBox": `selectorBox_H22mG`,
	"selectorLabel": `selectorLabel_lehJE`,
	"selectedElement": `selectedElement_CMaB2`,
	"selectorControls": `selectorControls_ZBLj6`,
	"selectionButtons": `selectionButtons_N5VF_`,
	"selectionButton": `selectionButton_nFEkt`,
	"continueButton": `continueButton_CR6ME`,
	"selectorForm": `selectorForm_K31Ac`,
	"selectorInput": `selectorInput_LhHPX`,
	"selectorSelect": `selectorSelect_gxme9`,
	"selectorTextarea": `selectorTextarea_ZyjFq`,
	"selectorActions": `selectorActions_fdmed`,
	"addButton": `addButton_we6Et`,
	"cancelButton": `cancelButton_d74kJ`,
	"selectorsList": `selectorsList_tFydt`,
	"selectorItem": `selectorItem_ufm2a`,
	"selectorInfo": `selectorInfo_EiZ8m`,
	"selectorType": `selectorType_zR_i8`,
	"selectorPath": `selectorPath_KaD4o`,
	"removeButton": `removeButton_ypHhk`,
	"templateContainer": `templateContainer_dl42I`,
	"templateHeader": `templateHeader_AeaQf`,
	"templateContent": `templateContent_uwtKp`,
	"templateInfo": `templateInfo_vE406`,
	"templateNameInput": `templateNameInput_ctN5M`,
	"templateDescriptionInput": `templateDescriptionInput_UuUyB`,
	"stepsContainer": `stepsContainer_xk7mO`,
	"stepsList": `stepsList_LJNM6`,
	"stepItem": `stepItem_aHyQh`,
	"stepHeader": `stepHeader_Di766`,
	"stepNumber": `stepNumber_Jvdjn`,
	"stepType": `stepType_c6ITv`,
	"stepActions": `stepActions_urzia`,
	"addStepForm": `addStepForm_IfQHU`,
	"stepInput": `stepInput_haG3V`,
	"stepSelect": `stepSelect_evUjj`,
	"addStepButton": `addStepButton_kAWvh`,
	"templateActions": `templateActions_P3WS1`,
	"saveButton": `saveButton_CrT_p`,
	"executeButton": `executeButton_cR3UZ`,
	"exampleContainer": `exampleContainer_lXAe4`,
	"exampleHeader": `exampleHeader_Oh7dB`,
	"exampleContent": `exampleContent_tjDTj`,
	"executionControls": `executionControls_XeikW`,
	"executionTime": `executionTime_eYUnt`,
	"resultsContainer": `resultsContainer_GlAzG`,
	"resultsTable": `resultsTable_iXqD3`,
	"status": `status_FH5B9`,
	"success": `success_EO4Rg`,
	"error": `error_sYyVc`,
	"warning": `warning_A41PC`,
	"noResults": `noResults_roBD3`,
	"exampleActions": `exampleActions_Qyekb`,
	"backButton": `backButton_nFWeG`,
	"newScrapingButton": `newScrapingButton_Vrnbb`,
	"errorContainer": `errorContainer_C25lC`
};
export default ___CSS_LOADER_EXPORT___;
